import SkipLink from "@components/SkipLink";
import {useTranslation} from "ni18n";
import React from "react";

type Props = {
  resultCount: number;
  shouldShowResultCount: boolean;
  skipTargetId: string;
  text?: string;
};

const ListPrefix: React.FC<Props> = React.memo(function ListPrefix({
  shouldShowResultCount,
  resultCount,
  skipTargetId,
  text,
}) {
  const i18n = useTranslation();
  return (
    <div className={`df aic jcsb ${shouldShowResultCount ? "" : "h0"}`}>
      {shouldShowResultCount && (
        <h3 className="font-ir fs14">{i18n.t("{{count}} results", {count: resultCount})}</h3>
      )}
      <span className="pos-a right0 top0 bottom0">
        <SkipLink
          item={{
            targetId: skipTargetId || "insurance-and-pricing",
            text: text || i18n.t("Skip list"),
          }}
          showOnFocus
        />
      </span>
    </div>
  );
});

export default ListPrefix;
